export const API_URL =
  process.env.REACT_APP_API_URL || 'https://api.dev.microstarlogistics.com/collections'

// To be used for testing purposes in local environment only
// export const API_URL_TEST = 'https://api.tst.microstarlogistics.com/collections'
// export const API_URL_PROD = 'https://prod-api.microstarlogistics.com/collections'
export const LOCAL_STORAGE_KEY_HAS_USER_CONSENTED_TO_COOKIES = 'hasUserConsentedToCookies'
export const LOCAL_STORAGE_KEY_CHOSEN_LOCATION = 'chosenLocation'
export const LOCAL_STORAGE_KEY_LAST_SUBMISSION_DATE = 'lastSubmissionDate'

// Deprecated collection-form keys. Startup cleanup removes them from browsers.
// Keep these names through 2027-09-30, then delete the cleanup with them.
export const LOCAL_STORAGE_KEY_COLLECTION_DAYS_LIST = 'kegCollectionDaysList'
export const LOCAL_STORAGE_KEY_COLLECTION_TIME_RANGE = 'kegCollectionTimeRange'
export const LOCAL_STORAGE_KEY_COLLECTION_PICKUP_LOCATION = 'kegCollectionPickupLocation'
export const LOCAL_STORAGE_KEY_COLLECTION_PHONE_NUMBER = 'kegCollectionPhoneNumber'
export const LOCAL_STORAGE_KEY_COLLECTION_PICKUP_INSTRUCTIONS = 'kegCollectionPickupInstructions'
